export default __webpack_public_path__ + "b30d732c0f09f299b20c8afe92a19f25.png";